import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import rootReducer from "./rootReducer";
import { createFilter } from "redux-persist-transform-filter";

const userFilter = createFilter("user", ["tabUsers"]);

// Configuration for redux-persist
const persistConfig = {
  key: "root", // key is required
  storage, // storage is now required
  whitelist: ["auth", "user"],
  transforms: [userFilter],
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/PURGE'],
      },
    }),
});

// Create a persistor
export const persistor = persistStore(store);
